<div class="modal-header bg-header-modal">
  <h5 class="modal-title">
    {{ title }}
  </h5>
  <button
    id="btn-close-icon"
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
    (click)="onClose()"
  >
    <span aria-hidden="false" class="text-white">×</span>
  </button>
</div>
<div class="card-body" [ngClass]="{'p-0': removePadding}">
  <div>
    <ng-content select="[appModalBody]"></ng-content>
  </div>
  <div>
    <ng-content select="[appModalFooter]"></ng-content>
  </div>
</div>
